// Market listing rules (copied from the reference game's Community Market,
// pokeidle-calibration docs/04, section 5.3-5.6). Coins only: the gem market
// stays off.
//
// - Sales pay 15% to the house (burned), rounded up, on what the buyer paid.
// - Items are priced per unit; a buyer takes any number of the units left.
//   Creatures, relics and shrines are always one unit.
// - At most MARKET_MAX_OPEN open listings per player, and one per item kind:
//   listing more of an item you already list adds to that listing.
// - After cancelling a listing, the same thing (item kind, creature, relic or
//   shrine) can't be listed again for MARKET_RELIST_MS.
// - Price lock: a listing's price can't change during its hold (the draw
//   window, CONFIG.marketHoldMs); changing the price or adding units starts a
//   new hold. A buy names the unit price the buyer saw and is refused if the
//   price went up since.
// Listings from before these rules keep working until sold or cancelled: an
// old item lot (unit 0) still sells whole, at its lot price.
import { CONFIG } from './config.ts';

/** Sale fee in basis points (15%). */
export const MARKET_FEE_BP = Math.round(CONFIG.marketFeeCoins * 10_000);
export const MARKET_MAX_OPEN = 20;
export const MARKET_RELIST_MS = 30 * 60_000;
/** Lowest unit price: below 2 the rounded-up fee would take the whole sale. */
export const MARKET_MIN_UNIT = 2;

/** The house's cut of one sale of `total` coins: 15% rounded up, never more than the sale. */
export function marketFee(total: number): number {
  const t = Math.max(0, Math.floor(total));
  return Math.min(t, Math.ceil((t * MARKET_FEE_BP) / 10_000));
}

/** The 1% listing fee (min 10) on the value put up for sale. */
export function listingFee(value: number): number {
  return Math.max(10, Math.floor(value * 0.01));
}

/**
 * Unit price of a listing row: its unit column, or the price of a single-unit
 * listing. 0 means an old multi-unit lot, which sells whole.
 */
export function unitOf(r: { unit?: number | null; qty: number; price: number }): number {
  return r.unit ? r.unit : r.qty === 1 ? r.price : 0;
}
